import { baseUrl } from '@/Global';
import APIHelper from '@/api/APIHelper';
import { defineComponent, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import DesItem from '@/components/common/DesItem.vue';
export default defineComponent({
  name: 'ProductDetails',
  components: {
    DesItem
  },
  setup() {
    const route = useRoute();
    const imgUrl = ref(baseUrl + 'images/bathroom/20170824083345496.jpg');
    const styles = ref({
      title: '',
      style: [],
      features: [],
      description: [],
      applications: [],
      DetailImage: [],
      video: ''
    });
    const list = ref([]);
    const className = ref('');
    const listRef = ref(null);
    let index = 0;
    /*const getRandomColor=()=>{
        // 生成0-15之间的随机数，然后转换为16进制表示（0-F）
        var hexDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
        var color = '#';
        
        for (var i = 0; i < 6; i++) {
            color += hexDigits[Math.floor(Math.random() * 16)];
        }
        
        return color;
    }*/
    const getData = () => {
      console.log(route.params);
      APIHelper.getInstance().getJson(baseUrl + 'json/product/' + route.params.name + '.json').then(res => {
        //console.log(res)
        styles.value = res;
        imgUrl.value = baseUrl + res.img;
      });
      //
      if (typeof route.params.class == 'string') className.value = route.params.class;
      APIHelper.getInstance().getJson(baseUrl + 'json/' + route.params.class + '.json').then(res => {
        console.log(res);
        list.value = res;
      });
    };
    const onClickLeft = () => {
      index++;
      if (index >= list.value.length) index = list.value.length - 1;
      //console.log(listRef.value.children[index])
      const el = listRef.value.children[index];
      if (el) listRef.value.scrollTo({
        left: (el.clientWidth + 20) * index,
        behavior: 'smooth'
      });
    };
    const onClickRight = () => {
      index--;
      if (index < 0) index = 0;
      //console.log(listRef.value.children[index])
      const el = listRef.value.children[index];
      if (el) listRef.value.scrollTo({
        left: (el.clientWidth + 20) * index,
        behavior: 'smooth'
      });
    };
    const onMouseDown = e => {
      //console.log(e)
    };
    onMounted(() => {
      getData();
      watch(() => route.params.name, newVal => {
        console.log(newVal);
        getData();
      });
    });
    return {
      imgUrl,
      styles,
      baseUrl,
      list,
      className,
      listRef,
      onClickLeft,
      onClickRight,
      onMouseDown
    };
  }
});